import {
    Component,
    Host,
    h,
    Event,
    Prop,
    Watch,
    State,
} from "@stencil/core";
import type { EventEmitter } from "@stencil/core";

import {
    EMPTY_INPUT_MESSAGE,
    LONG_INPUT_MESSAGE,
    INPUT_MAX_LENGTH,
    INPUT_PLACEHOLDER,
} from "../../../../global/variables";

import type {BotId} from "../../../../global/models/models";

@Component({
    tag: "c-input-text",
    styleUrl: "c-input-text.scss",
})
export class CInputText {
    defaultPlaceholder = INPUT_PLACEHOLDER;
    inputElement: HTMLInputElement;
    @Event() inputText: EventEmitter<string>;
    @State() emptyUserInput = false;
    @State() longUserInput = false;
    @State() infoMessage: string;
    @Prop() disabled = false;
    @Prop() botId?: BotId;
    @Prop() placeholder;
    @Watch("disabled")
    watchHandler(disabled: boolean): void {
        if (!disabled) {
            setTimeout(() => this.inputElement.focus(), 0);
        }
    }

    handleKeyUp(e: any) {
        if (e.key === "Enter") {
            this.processInput();
        } else if (this.emptyUserInput) {
            this.emptyUserInput = false;
            this.infoMessage = "";
        }
    }

    handleButtonClick() {
        this.processInput();
    }

    // Check if the user input is too long (live check)
    validateInput() {
        const input = this.inputElement.value;
        const maxLength = this.botId === "INKASSO" ? 400 : INPUT_MAX_LENGTH;
        if (input.length > maxLength) {
            this.emptyUserInput = false;
            this.longUserInput = true;
            this.infoMessage = LONG_INPUT_MESSAGE;
        } else if (this.longUserInput) {
            this.longUserInput = false;
            this.infoMessage = "";
        }
    }

    processInput() {
        if (this.longUserInput) {
            this.inputElement.focus();
            return;
        }
        // Check if the message is not empty before sending it to the bot
        this.inputElement.value = this.inputElement.value.trim();
        if (this.inputElement.value.length === 0) {
            this.emptyUserInput = true;
            this.infoMessage = EMPTY_INPUT_MESSAGE;
            this.inputElement.focus();
            return;
        }
        this.emitValue();
        this.resetInput();
    }

    emitValue() {
        this.inputText.emit(this.inputElement.value);
    }

    resetInput() {
        this.inputElement.value = "";
    }

    handleSubmit(e: Event) {
        // Prevent page from reloading when user submits the form
        e.preventDefault();
    }

    componentDidLoad() {
        if (this.disabled) {
            return;
        }
        this.inputElement.focus();
    }

    getPlaceholder() {
        if (this.disabled) {
            return "";
        }
        if (this.placeholder) {
            return this.placeholder;
        }
        return this.defaultPlaceholder;
    }
    render() {
        return (
            <Host class={this.disabled ? "is-disabled" : ""}>
                {(this.emptyUserInput || this.longUserInput) && (
                    <div role="alert" aria-relevant="all" class="info-message">
                        <p>{this.infoMessage}</p>
                    </div>
                )}
                <form onSubmit={(e: Event) => this.handleSubmit(e)}>
                    <input
                        type="text"
                        title="Nachricht eingeben"
                        aria-label={this.infoMessage || "Nachricht eingeben"}
                        aria-controls="cb-conversation"
                        autocomplete="off"
                        disabled={this.disabled}
                        ref={(el: HTMLInputElement) => (this.inputElement = el)}
                        placeholder={this.getPlaceholder()}
                        aria-invalid={this.infoMessage ? "true" : "false"}
                        onInput={this.validateInput.bind(this)}
                        onKeyUp={this.handleKeyUp.bind(this)}
                    />
                    <button
                        type="submit"
                        title="Nachricht absenden"
                        aria-label="Nachricht absenden"
                        disabled={this.disabled}
                        onClick={this.handleButtonClick.bind(this)}
                    >
                        <i aria-hidden="true" class="ba-icon ba-icon-chevron-right"/>
                    </button>
                </form>
            </Host>
        );
    }
}
